<div class="w-full overflow-auto flex flex-col justify-center items-center p-2 ">

  <!-- steps on desktop -->
  <div class="flex flex-row items-start text-center justify-between  border-b-2 border-primary-500 w-full"
    *ngIf="!isMobile">
    <div *ngFor="let tab of fields; let i = index" class="step">
      <button *ngIf="options?.autoDisable" [id]="tab.number"
        [disabled]="tab.number <= activeNumber ? false : true"
        class="circle-button disabled:cursor-default tabs-hover  disabled:bg-primary-700/30 disabled:text-primary-500 no-up-on-hover rounded-full w-12 h-12 text-xl {{tab.routerOutlet == active ? 'step-active' : 'step-noactive'}}"
        [routerLink]="[tab.routerOutlet, tab.routerParams]">
        {{tab.number}}
      </button>
      <button *ngIf="!options?.autoDisable" [id]="tab.number" [disabled]="tab.disabled"
        class="circle-button disabled:cursor-default tabs-hover  disabled:bg-primary-700/30 disabled:text-primary-500 no-up-on-hover rounded-full w-12 h-12 text-xl {{tab.routerOutlet == active ? 'step-active' : 'step-noactive'}}"
        [routerLink]="[tab.routerOutlet, tab.routerParams]">
        {{tab.number}}
      </button>
      <p [id]="tab.title + 'p'" class="text-center p-2 ">{{tab.title}}</p>
    </div>
  </div>


  <!-- steps on mobile -->
  <div class="flex justify-between items-center w-full" *ngIf="isMobile">


    <!-- fake invisible button -->
    <div class="flex flex-col justify-center items-center w-1/6" *ngIf="selected == 1">
      <div class="text-primary-800/50 bg-primary-100/50 p-2 rounded-full text-xl flex items-end justify-end w-10/12">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-full">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M15 6l-6 6l6 6" />
        </svg>

      </div>

    </div>

    <!--previous-->
    <div class="flex flex-col justify-center items-center w-1/6" *ngIf="selected > 1">
      <div (click)="showList = false"
        class="text-primary-800 bg-primary-100 p-2 rounded-full text-xl flex items-end justify-end w-10/12"
        [routerLink]="[fields[selected -2].routerOutlet, fields[selected -2].routerParams]">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-full">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M15 6l-6 6l6 6" />
        </svg>

      </div>

    </div>






    <div class="flex flex-col justify-center items-center w-4/6">
      <div class="rounded-3xl p-2 w-full text-xl step-active shadow-xl" (click)="showList = !showList">
        <p [id]="fields[selected -1].title + 'p'" class="text-center p-2 whitespace-normal">{{fields[selected
          -1].number}} - {{fields[selected -1].title}}</p>
      </div>
      
    </div>

    <!-- next -->
    <div class="flex flex-col justify-center items-center w-1/6" *ngIf="selected < fields.length">
      <div (click)="showList = false"
        class="text-primary-800 bg-primary-100 p-2 rounded-full text-xl flex items-end justify-end w-10/12"
        [routerLink]="[fields[selected].routerOutlet, fields[selected].routerParams]">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-full">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 6l6 6l-6 6" />
        </svg>

      </div>

    </div>

    <!-- fake invisible button -->
    <div class="flex flex-col justify-center items-center  w-1/6" *ngIf="selected >= fields.length">
      <div (click)="showList = false"
        class="text-primary-800/50 bg-primary-100/50 p-2 rounded-full text-xl flex items-end justify-end w-10/12">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-full">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 6l6 6l-6 6" />
        </svg>

      </div>
    </div>

  </div>

  <div @slideDownUp class="flex flex-col gap-2 items-start justify-between w-full mt-4" *ngIf="showList">
    <p>Tutti gli step:</p>
    <div *ngFor="let tab of fields; let i = index" class="step w-full">
      <button *ngIf="options?.autoDisable" [id]="tab.number" (click)="showList = false"
        [disabled]="tab.number <= activeNumber ? false : true"
        class="disabled:cursor-default tabs-hover  disabled:bg-primary-700/30 disabled:text-primary-500 no-up-on-hover rounded-2xl w-full text-xl {{tab.routerOutlet == active ? 'step-active' : 'step-noactive'}}"
        [routerLink]="[tab.routerOutlet, tab.routerParams]">
        <p [id]="tab.title + 'p'" class="text p-2 w-full">{{tab.number}} - {{tab.title}}</p>
      </button>
      <button *ngIf="!options?.autoDisable" [id]="tab.number" [disabled]="tab.disabled" (click)="showList = false"
        class=" disabled:cursor-default tabs-hover  disabled:bg-primary-700/30 disabled:text-primary-500 no-up-on-hover rounded-2xl w-full text-xl {{tab.routerOutlet == active ? 'step-active' : 'step-noactive'}}"
        [routerLink]="[tab.routerOutlet, tab.routerParams]">
        <p [id]="tab.title + 'p'" class="text p-2 w-full">{{tab.number}} - {{tab.title}}</p>
      </button>

    </div>
  </div>
</div>